import { useDispatch, useSelector } from 'react-redux';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import { useEffect, useState } from 'react';
import { setSuccessMessage } from '../../client/Redux/actions/junoAction';

const useEmailNotification = () => {
    const { updateUsersData } = useJunoCommonFunctions();
    const clientData = useSelector(state => state.juno.clientData);
    const dispatch = useDispatch();

    const [receiveTransactionEmail, setReceiveTransactionEmail] = useState(true);

    useEffect(() => {
        if (clientData && clientData.receiveTransactionEmails !== undefined) {
            setReceiveTransactionEmail(clientData?.receiveTransactionEmails);
        }
    }, [clientData]);

    const handleGetEmail = () => {
        const isEmailNotificationsEnabled = !receiveTransactionEmail;
        setReceiveTransactionEmail(isEmailNotificationsEnabled);

        const updateEmailNotification = updateUsersData({
            receiveTransactionEmail: isEmailNotificationsEnabled,
        });

        updateEmailNotification
            .then(data => {
                dispatch(setSuccessMessage('Account details updated successfully'));
            })
            .catch(err => {
                console.error('Failed to update email preference:', err);
                setReceiveTransactionEmail(!isEmailNotificationsEnabled);
            });
    };

    return [receiveTransactionEmail, handleGetEmail];
};

export default useEmailNotification;
